import { ModelApi } from '@/services/api/modelApi'
import { IPricingLimitProfile } from '@/modules/seller-management/pricing-limit-profile/types/pricingLimitProfileTypes'

export class PricingLimitProfileEndpoints extends ModelApi<IPricingLimitProfile> {
  constructor() {
    super('pricing_profile')
  }
}
